import { FC } from 'react'

import { cn } from 'utils'

import { TeamMemberAvatar, TeamMemberAvatarProps } from './team-member-avatar'
import classes from './avatars-of-team-members.module.css'
import classesAvatar from './team-member-avatar.module.css'

interface AvatarsOfTeamMembersProps {
  peopleAvatars: TeamMemberAvatarProps['person'][]
}

const getEmptyAvatar = (avatarsLength): string[] => {
  const MAX_AVATARS = 6
  const emptySectionNumber = MAX_AVATARS - avatarsLength
  return new Array(emptySectionNumber < 0 ? 0 : emptySectionNumber).fill(() => '')
}

export const AvatarsOfTeamMembers: FC<AvatarsOfTeamMembersProps> = ({ peopleAvatars }) => {
  return (
    <div className={classes.container}>
      {peopleAvatars.map((person) => (
        <TeamMemberAvatar
          person={person}
          key={person.full_name}
          width={100}
          height={100}
          className={classes.image}
        />
      ))}
      {getEmptyAvatar(peopleAvatars.length).map((_, index) => (
        <div className={cn(classesAvatar.photo, classes.empty)} key={index} />
      ))}
    </div>
  )
}
